var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('section',[_c('v-row',[_c('v-col',{staticClass:"d-flex align-center"},[_c('h1',{staticClass:"font-weight-light mb-2 headline",domProps:{"textContent":_vm._s(("" + _vm.title))}})])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }